import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import SetaLogo from './SetaLogo';
import { navItems } from '../mock';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Track active section only on home page
  useEffect(() => {
    if (!isHome) return;
    const handler = () => {
      const sections = navItems.map((n) => document.getElementById(n.id));
      const scrollPos = window.scrollY + 200;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i];
        if (el && el.offsetTop <= scrollPos) {
          setActive(navItems[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handler);
    handler();
    return () => window.removeEventListener('scroll', handler);
  }, [isHome]);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const goTo = (id) => {
    setOpen(false);
    if (isHome) {
      scrollToSection(id);
    } else {
      // navigate to home, then scroll after mount
      navigate('/');
      setTimeout(() => scrollToSection(id), 120);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-[#0e0e0e] shadow-[0_4px_20px_rgba(0,0,0,0.45)]"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between py-2">
        <Link to="/" className="flex-shrink-0 flex items-center" aria-label="Ir para o topo">
          <SetaLogo height={64} />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => goTo(item.id)}
              className={`relative px-2 py-2 text-[12px] tracking-[0.18em] font-semibold transition-colors duration-200 ${
                isHome && active === item.id ? 'text-[#E8C16A]' : 'text-white/95 hover:text-[#E8C16A]'
              }`}
            >
              {item.label}
              <span
                className={`absolute left-3 right-3 -bottom-[6px] h-[2px] bg-[#E8C16A] transition-transform duration-300 origin-center ${
                  isHome && active === item.id ? 'scale-x-100' : 'scale-x-0'
                }`}
              />
            </button>
          ))}
          <a
            href="http://app.setaadministracao.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 inline-flex items-center justify-center px-3.5 py-2 text-[11px] tracking-[0.08em] font-bold rounded-full bg-[#C99A36] text-[#0e0e0e] hover:bg-[#E8C16A] transition-colors duration-200 whitespace-nowrap"
          >
            Área de Membro
          </a>
        </nav>

        <button
          className="lg:hidden p-2 text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#0e0e0e] border-t border-white/10">
          <div className="flex flex-col px-6 py-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => goTo(item.id)}
                className={`text-left py-3 text-[13px] tracking-[0.18em] font-semibold border-b border-white/10 ${
                  isHome && active === item.id ? 'text-[#E8C16A]' : 'text-white/85'
                }`}
              >
                {item.label}
              </button>
            ))}
            <a
              href="http://app.setaadministracao.com/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-4 mx-auto inline-flex items-center justify-center px-3.5 py-2.5 text-[12px] tracking-[0.08em] font-bold rounded-full bg-[#C99A36] text-[#0e0e0e] hover:bg-[#E8C16A] transition-colors duration-200 whitespace-nowrap"
            >
              Área de Membro
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
